module.exports = __webpack_public_path__ + "img/total-scan.9ca94cd3.svg";